module.exports = __webpack_public_path__ + "static/media/brand-logo.e9613530.png";